<template>
  <div class="pets-component">
    <img class="banner-img" src="../../assets/img/home/1.jpg" style="width:100%" alt="">

    <div class="container">
      <div class="row">
        <h2 class="title">{{ $t('telas.pets.title') }}</h2>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-12 text">
          <p>
            {{ $t('telas.pets.descricao.intro') }}
            <br><br>
            <ol>
              <li>{{ $t('telas.pets.descricao.termo1') }}</li>
              <li>{{ $t('telas.pets.descricao.termo2') }}</li>
              <li>{{ $t('telas.pets.descricao.termo3') }}</li>
              <li>{{ $t('telas.pets.descricao.termo4') }}</li>
              <li>{{ $t('telas.pets.descricao.termo5') }}</li>
              <li>{{ $t('telas.pets.descricao.termo6') }}</li>
              <li>{{ $t('telas.pets.descricao.termo7') }}</li>
              <li>{{ $t('telas.pets.descricao.termo8') }}</li>
              <li>{{ $t('telas.pets.descricao.termo9') }}</li>
              <li>{{ $t('telas.pets.descricao.termo10') }}</li>
              <li>{{ $t('telas.pets.descricao.termo11') }}</li>
              <li>{{ $t('telas.pets.descricao.termo12') }}</li>
              <li>{{ $t('telas.pets.descricao.termo13') }}</li>
              <li>{{ $t('telas.pets.descricao.termo14') }}</li>
              <li>{{ $t('telas.pets.descricao.termo15') }}</li>
              <li>{{ $t('telas.pets.descricao.termo16') }}</li>
              <li>{{ $t('telas.pets.descricao.termo17') }}</li>
            </ol>
          </p>
        </div>
      </div>

      <reserva :header="true"></reserva>
    </div>
  </div>
</template>

<script>
import reserva from '../../components/reservation-component/ReservationComponent'
export default {
  name: 'Pets',

  components: {reserva}
}
</script>

<style>
.pets-component {
  background-color: white;
  font-family: 'Quicksand', sans-serif;
  padding-bottom: 80px;
}

.pets-component .title {
  width: 100%;
  text-align: center;
  color: rgb(118, 106, 49);
  padding-top: 40px;
  margin-bottom: 40px;
  text-transform: capitalize;
}

.pets-component .text p {
  color: black;
  text-align: justify;
}

.pets-component .banner-img {
  max-height: 506.4px;
  width: 100%;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/pages/pets/Pets.vue